import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/habilidad/importer/habilidadImporterActions';

export default importerReducers(actions);
